export default __webpack_public_path__ + "static/media/outlook.0b6b2dec.svg";